export default __webpack_public_path__ + "assets/png/ec271cea99764d8adc14834deef54edd.png";